import React, { useState } from 'react'

import { LoadingSkeleton } from '@digitalmedia/sn-design-system'

import CalendarIcon from '../calendar_icon/CalendarIcon'
import Calendar from 'react-calendar'
import { addDays, subtractDays } from 'utils/js/time_helpers'
import moment from 'moment'

import './DatePicker.scss'

const DatePicker = ({ date, onDateChange, loading }) => {
    const [showCalendar, setShowCalendar] = useState(false)

    const changeDate = (newDate, usingCalendar = false) => {
        setShowCalendar(false)
        onDateChange(newDate, usingCalendar)
    }

    const addDay = () => {
        const newDate = addDays(date, 1)
        changeDate(newDate)
    }
    const subtractDay = () => {
        const newDate = subtractDays(date, 1)
        changeDate(newDate)
    }
    const switchShowCalendar = () => {
        setShowCalendar(!showCalendar)
    }

    return (
        <>
            <div className="datepicker__container">
                <div onClick={subtractDay} className="arrow__wrapper">
                    <div className="arrow left" />
                </div>
                {loading ? (
                    <LoadingSkeleton width={190} height={23} borderRadius={4} />
                ) : (
                    <div className="date">{moment(date).format('dddd, MMMM D')}</div>
                )}
                <div onClick={addDay} className="arrow__wrapper">
                    <div className="arrow right" />
                </div>
                <div className="calendar_icon__wrapper">
                    <CalendarIcon width="24" height="24" onClick={switchShowCalendar} />
                </div>
            </div>

            {showCalendar && (
                <>
                    <div
                        onClick={() => setShowCalendar(false)}
                        className="calendar__background"
                    ></div>
                    <div className="calendar__wrapper">
                        <Calendar
                            onChange={date => changeDate(date, true)}
                            value={date}
                            calendarType="US"
                        />
                    </div>
                </>
            )}
        </>
    )
}

export default DatePicker
